import { searchRequisition, getOrders } from './requisition';

export default {
  getRequisitions: searchRequisition,
  getOrders,
};
